"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionType = void 0;

/**
 * Master list of valid schemas for analytics actions
 *
 * Each event describes one ActionType
 */

/**
 * The top-level actions an Event describes.
 *
 * Each ActionType corresponds with a table in Redshift.
 */
var ActionType;
exports.ActionType = ActionType;

(function (ActionType) {
  ActionType["addedArtworkToArtworkList"] = "addedArtworkToArtworkList";
  ActionType["addedToAlbum"] = "addedToAlbum";
  ActionType["addArtworkDetails"] = "addArtworkDetails";
  ActionType["addCollectedArtwork"] = "addCollectedArtwork";
  ActionType["addressAutoCompletionResult"] = "addressAutoCompletionResult";
  ActionType["addNewArtistName"] = "addNewArtistName";
  ActionType["addToCalendar"] = "addToCalendar";
  ActionType["artworkDetailsCompleted"] = "artworkDetailsCompleted";
  ActionType["auctionPageView"] = "auctionPageView";
  ActionType["auctionResultsFilterParamsChanged"] = "auctionResultsFilterParamsChanged";
  ActionType["authImpression"] = "authImpression";
  ActionType["bidPageView"] = "bidPageView";
  ActionType["checkedAccountBalance"] = "checkedAccountBalance";
  ActionType["clickedActiveBid"] = "clickedActiveBid";
  ActionType["clickedActivityPanelNotificationItem"] = "clickedActivityPanelNotificationItem";
  ActionType["clickedActivityPanelTab"] = "clickedActivityPanelTab";
  ActionType["clickedAddFilters"] = "clickedAddFilters";
  ActionType["clickedAddMissingArtworksDetails"] = "clickedAddMissingArtworksDetails";
  ActionType["clickedAddNewShippingAddress"] = "clickedAddNewShippingAddress";
  ActionType["clickedAddWorksToFair"] = "clickedAddWorksToFair";
  ActionType["clickedAlertsFilters"] = "clickedAlertsFilters";
  ActionType["clickedAppDownload"] = "clickedAppDownload";
  ActionType["clickedArticleGroup"] = "clickedArticleGroup";
  ActionType["clickedArticleShare"] = "clickedArticleShare";
  ActionType["clickedArtistGroup"] = "clickedArtistGroup";
  ActionType["clickedArtistSeriesGroup"] = "clickedArtistSeriesGroup";
  ActionType["clickedArtworkGroup"] = "clickedArtworkGroup";
  ActionType["clickedAuctionGroup"] = "clickedAuctionGroup";
  ActionType["clickedAuctionResultItem"] = "clickedAuctionResultItem";
  ActionType["clickedBuyerProtection"] = "clickedBuyerProtection";
  ActionType["clickedChangePage"] = "clickedChangePage";
  ActionType["clickedChangePaymentMethod"] = "clickedChangePaymentMethod";
  ActionType["clickedChangeShippingAddress"] = "clickedChangeShippingAddress";
  ActionType["clickedChangeShippingMethod"] = "clickedChangeShippingMethod";
  ActionType["clickedCollectionGroup"] = "clickedCollectionGroup";
  ActionType["clickedCreateAlert"] = "clickedCreateAlert";
  ActionType["clickedDeliveryMethod"] = "clickedDeliveryMethod";
  ActionType["clickedEditArtwork"] = "clickedEditArtwork";
  ActionType["clickedExpansionToggle"] = "clickedExpansionToggle";
  ActionType["clickedExpandFilterPanel"] = "clickedExpandFilterPanel";
  ActionType["clickedExternalNewsSource"] = "clickedExternalNewsSource";
  ActionType["clickedFairCard"] = "clickedFairCard";
  ActionType["clickedFairGroup"] = "clickedFairGroup";
  ActionType["clickedGalleryGroup"] = "clickedGalleryGroup";
  ActionType["clickedLoadMore"] = "clickedLoadMore";
  ActionType["clickedMainArtworkGrid"] = "clickedMainArtworkGrid";
  ActionType["clickedMyCollectionInsightsMedianAuctionRailItem"] = "clickedMyCollectionInsightsMedianAuctionRailItem";
  ActionType["clickedNavigationTab"] = "clickedNavigationTab";
  ActionType["clickedNotificationsBell"] = "clickedNotificationsBell";
  ActionType["clickedOfferActions"] = "clickedOfferActions";
  ActionType["clickedOfferOption"] = "clickedOfferOption";
  ActionType["clickedOnArtworkShippingUnitsDropdown"] = "clickedOnArtworkShippingUnitsDropdown";
  ActionType["clickedOnArtworkShippingWeight"] = "clickedOnArtworkShippingWeight";
  ActionType["clickedOnBuyNowCheckbox"] = "clickedOnBuyNowCheckbox";
  ActionType["clickedOnFramedMeasurements"] = "clickedOnFramedMeasurements";
  ActionType["clickedOnFramedMeasurementsDropdown"] = "clickedOnFramedMeasurementsDropdown";
  ActionType["clickedOnMakeOfferCheckbox"] = "clickedOnMakeOfferCheckbox";
  ActionType["clickedOnDuplicateArtwork"] = "clickedOnDuplicateArtwork";
  ActionType["clickedOnPagination"] = "clickedOnPagination";
  ActionType["clickedOnPriceDisplayDropdown"] = "clickedOnPriceDisplayDropdown";
  ActionType["clickedPublish"] = "clickedPublish";
  ActionType["clickedOnSubmitOrder"] = "clickedOnSubmitOrder";
  ActionType["clickedOrderPage"] = "clickedOrderPage";
  ActionType["clickedOrderSummary"] = "clickedOrderSummary";
  ActionType["clickedDismissInquiry"] = "clickedDismissInquiry";
  ActionType["clickedMarkSpam"] = "clickedMarkSpam";
  ActionType["clickedMarkSold"] = "clickedMarkSold";
  ActionType["clickedNavBar"] = "clickedNavBar";
  ActionType["clickedPartnerCard"] = "clickedPartnerCard";
  ActionType["clickedPartnerLink"] = "clickedPartnerLink";
  ActionType["clickedPaymentMethod"] = "clickedPaymentMethod";
  ActionType["clickedPaymentDetails"] = "clickedPaymentDetails";
  ActionType["clickedPlayVideo"] = "clickedPlayVideo";
  ActionType["clickedPromoSpace"] = "clickedPromoSpace";
  ActionType["clickedRegisterToBid"] = "clickedRegisterToBid";
  ActionType["clickedSelectShippingOption"] = "clickedSelectShippingOption";
  ActionType["clickedStartPartnerOffer"] = "clickedStartPartnerOffer";
  ActionType["clickedSendPartnerOffer"] = "clickedSendPartnerOffer";
  ActionType["clickedShippingAddress"] = "clickedShippingAddress";
  ActionType["clickedShowGroup"] = "clickedShowGroup";
  ActionType["clickedMarketingModal"] = "clickedMarketingModal";
  ActionType["clickedShowMore"] = "clickedShowMore";
  ActionType["clickedSnooze"] = "clickedSnooze";
  ActionType["clickedUploadArtwork"] = "clickedUploadArtwork";
  ActionType["clickedSponsorLink"] = "clickedSponsorLink";
  ActionType["clickedTooltip"] = "clickedTooltip";
  ActionType["clickedUpdateArtwork"] = "clickedUpdateArtwork";
  ActionType["clickedVerifyIdentity"] = "clickedVerifyIdentity";
  ActionType["clickedViewingRoomCard"] = "clickedViewingRoomCard";
  ActionType["clickedValidationAddressOptions"] = "clickedValidationAddressOptions";
  ActionType["clickedCloseValidationAddressModal"] = "clickedCloseValidationAddressModal";
  ActionType["clickedVerifiedRepresentative"] = "clickedVerifiedRepresentative";
  ActionType["clickedGene"] = "clickedGene";
  ActionType["clickedHighlightAchievement"] = "clickedHighlightAchievement";
  ActionType["commercialFilterParamsChanged"] = "commercialFilterParamsChanged";
  ActionType["completedOfflineSync"] = "completedOfflineSync";
  ActionType["completedOnboarding"] = "completedOnboarding";
  ActionType["confirmBid"] = "confirmBid";
  ActionType["confirmRegistrationPageview"] = "confirmRegistrationPageview";
  ActionType["consignmentArtistFailed"] = "consignmentArtistFailed";
  ActionType["consignmentSubmitted"] = "consignmentSubmitted";
  ActionType["contactGallery"] = "contactGallery";
  ActionType["contactInformationCompleted"] = "contactInformationCompleted";
  ActionType["createdAlbum"] = "createdAlbum";
  ActionType["createdAccount"] = "createdAccount";
  ActionType["createdArtworkList"] = "createdArtworkList";
  ActionType["deleteCollectedArtwork"] = "deleteCollectedArtwork";
  ActionType["deletedArtworkList"] = "deletedArtworkList";
  ActionType["deletedSavedSearch"] = "deletedSavedSearch";
  ActionType["editCollectedArtwork"] = "editCollectedArtwork";
  ActionType["editedAutocompletedAddress"] = "editedAutocompletedAddress";
  ActionType["editedArtworkList"] = "editedArtworkList";
  ActionType["editedAlert"] = "editedAlert";
  ActionType["editedSavedSearch"] = "editedSavedSearch";
  ActionType["editedUserProfile"] = "editedUserProfile";
  ActionType["enterLiveAuction"] = "enterLiveAuction";
  ActionType["errorMessageViewed"] = "errorMessageViewed";
  ActionType["experimentViewed"] = "experiment_viewed";
  ActionType["itemViewed"] = "item_viewed";
  ActionType["uploadSizeLimitExceeded"] = "uploadSizeLimitExceeded";
  ActionType["focusedOnConversationMessageInput"] = "focusedOnConversationMessageInput";
  ActionType["focusedOnPriceDatabaseSearchInput"] = "focusedOnPriceDatabaseSearchInput";
  ActionType["focusedOnSearchInput"] = "focusedOnSearchInput";
  ActionType["followedArtist"] = "followedArtist";
  ActionType["followedFair"] = "followedFair";
  ActionType["followedGene"] = "followedGene";
  ActionType["followedPartner"] = "followedPartner";
  ActionType["impression"] = "impression";
  ActionType["longPressedArtwork"] = "longPressedArtwork";
  ActionType["maxBidSelected"] = "maxBidSelected";
  ActionType["myCollectionOnboardingCompleted"] = "myCollectionOnboardingCompleted";
  ActionType["onboardingUserInputData"] = "onboardingUserInputData";
  ActionType["priceDatabaseFilterParamsChanged"] = "priceDatabaseFilterParamsChanged";
  ActionType["promptForReview"] = "promptForReview";
  ActionType["railViewed"] = "railViewed";
  ActionType["validationAddressViewed"] = "validationAddressViewed";
  ActionType["registrationPageView"] = "registrationPageView";
  ActionType["registrationSubmitted"] = "registrationSubmitted";
  ActionType["resetYourPassword"] = "resetYourPassword";
  ActionType["saleScreenLoadComplete"] = "saleScreenLoadComplete";
  ActionType["saveCollectedArtwork"] = "saveCollectedArtwork";
  ActionType["savedCookieConsentPreferences"] = "savedCookieConsentPreferences";
  ActionType["screen"] = "screen";
  ActionType["selectedSearchSuggestionQuickNavigationItem"] = "selectedSearchSuggestionQuickNavigationItem";
  ActionType["sentContent"] = "sentContent";
  ActionType["searchedPriceDatabase"] = "searchedPriceDatabase";
  ActionType["searchedWithNoResults"] = "searchedWithNoResults";
  ActionType["searchedWithResults"] = "searchedWithResults";
  ActionType["selectArtistFromSearch"] = "selectArtistFromSearch";
  ActionType["selectArtworkFromGrid"] = "selectArtworkFromGrid";
  ActionType["clickedConversationsFilter"] = "clickedConversationsFilter";
  ActionType["selectedItemFromPriceDatabaseSearch"] = "selectedItemFromPriceDatabaseSearch";
  ActionType["selectedItemFromSearch"] = "selectedItemFromSearch";
  ActionType["selectedItemFromAddressAutoCompletion"] = "selectedItemFromAddressAutoCompletion";
  ActionType["selectedSuggestedFilter"] = "selectedSuggestedFilter";
  ActionType["selectedRecentPriceRange"] = "selectedRecentPriceRange";
  ActionType["sendOffersBannerViewed"] = "sendOffersBannerViewed";
  ActionType["sendOffersErrorMessage"] = "sendOffersErrorMessage";
  ActionType["sendOffersModalViewed"] = "sendOffersModalViewed";
  ActionType["sentArtworkInquiry"] = "sentArtworkInquiry";
  ActionType["sentConsignmentInquiry"] = "sentConsignmentInquiry";
  ActionType["sentConversationMessage"] = "sentConversationMessage";
  ActionType["sentRequestPriceEstimate"] = "sentRequestPriceEstimate";
  ActionType["share"] = "share";
  ActionType["startedOnboarding"] = "startedOnboarding";
  ActionType["submitAnotherArtwork"] = "submitAnotherArtwork";
  ActionType["successfullyLoggedIn"] = "successfullyLoggedIn";
  ActionType["tappedActivityGroup"] = "tappedActivityGroup";
  ActionType["tappedArticleGroup"] = "tappedArticleGroup";
  ActionType["tappedArticleShare"] = "tappedArticleShare";
  ActionType["tappedArtistGroup"] = "tappedArtistGroup";
  ActionType["tappedArtistSeriesGroup"] = "tappedArtistSeriesGroup";
  ActionType["tappedArtworkGroup"] = "tappedArtworkGroup";
  ActionType["tappedAuctionGroup"] = "tappedAuctionGroup";
  ActionType["tappedAuctionResultGroup"] = "tappedAuctionResultGroup";
  ActionType["tappedBid"] = "tappedBid";
  ActionType["tappedBrowseSimilarArtworks"] = "tappedBrowseSimilarArtworks";
  ActionType["tappedBuyNow"] = "tappedBuyNow";
  ActionType["tappedCollectedArtwork"] = "tappedCollectedArtwork";
  ActionType["tappedCollectedArtworkImages"] = "tappedCollectedArtworkImages";
  ActionType["tappedCollectionGroup"] = "tappedCollectionGroup";
  ActionType["tappedConsign"] = "tappedConsign";
  ActionType["tappedContactGallery"] = "tappedContactGallery";
  ActionType["tappedConsignmentInquiry"] = "tappedConsignmentInquiry";
  ActionType["tappedCreateAlert"] = "tappedCreateAlert";
  ActionType["tappedCreateAlertHeader"] = "tappedCreateAlertHeader";
  ActionType["tappedExploreGroup"] = "tappedExploreGroup";
  ActionType["tappedExploreMyCollection"] = "tappedExploreMyCollection";
  ActionType["tappedFairCard"] = "tappedFairCard";
  ActionType["tappedFairGroup"] = "tappedFairGroup";
  ActionType["tappedInboxConversation"] = "tappedInboxConversation";
  ActionType["tappedInfoBubble"] = "tappedInfoBubble";
  ActionType["tappedLearnMore"] = "tappedLearnMore";
  ActionType["tappedLink"] = "tappedLink";
  ActionType["tappedMainArtworkGrid"] = "tappedMainArtworkGrid";
  ActionType["tappedMakeOffer"] = "tappedMakeOffer";
  ActionType["tappeMenuItem"] = "tappeMenuItem";
  ActionType["tappedMyCollectionAddArtworkArtist"] = "tappedMyCollectionAddArtworkArtist";
  ActionType["tappedMyCollectionInsightsMedianAuctionPriceChartCareerHighlight"] = "tappedMyCollectionInsightsMedianAuctionPriceChartCareerHighlight";
  ActionType["tappedMyCollectionInsightsMedianAuctionPriceChartCategory"] = "TappedMyCollectionInsightsMedianAuctionPriceChartCategory";
  ActionType["tappedMyCollectionInsightsMedianAuctionPriceChartTimeframe"] = "tappedMyCollectionInsightsMedianAuctionPriceChartTimeframe";
  ActionType["tappedMyCollectionInsightsMedianAuctionRailItem"] = "tappedMyCollectionInsightsMedianAuctionRailItem";
  ActionType["tappedNavigationTab"] = "tappedNavigationTab";
  ActionType["tappedPartnerCard"] = "tappedPartnerCard";
  ActionType["tappedProductCapabilitiesGroup"] = "tappedProductCapabilitiesGroup";
  ActionType["tappedPromoSpace"] = "tappedPromoSpace";
  ActionType["tappedRegisterToBid"] = "tappedRegisterToBid";
  ActionType["tappedRequestPriceEstimate"] = "tappedRequestPriceEstimate";
  ActionType["tappedSell"] = "tappedSell";
  ActionType["tappedSellArtwork"] = "tappedSellArtwork";
  ActionType["tappedShowGroup"] = "tappedShowGroup";
  ActionType["tappedShowMore"] = "tappedShowMore";
  ActionType["tappedSkip"] = "tappedSkip";
  ActionType["tappedTabBar"] = "tappedTabBar";
  ActionType["tappedUploadAnotherArtwork"] = "tappedUploadAnotherArtwork";
  ActionType["tappedVerifyIdentity"] = "tappedVerifyIdentity";
  ActionType["tappedViewingRoomCard"] = "tappedViewingRoomCard";
  ActionType["tappedViewingRoomGroup"] = "tappedViewingRoomGroup";
  ActionType["tappedViewOffer"] = "tappedViewOffer";
  ActionType["tappedVerifiedRepresentative"] = "tappedVerifiedRepresentative";
  ActionType["tappedGene"] = "tappedGene";
  ActionType["tappedHighlightAchievement"] = "tappedHighlightAchievement";
  ActionType["tappedNewsSection"] = "tappedNewsSection";
  ActionType["timeOnPage"] = "timeOnPage";
  ActionType["toggledAccordion"] = "toggledAccordion";
  ActionType["toggledNotification"] = "toggledNotification";
  ActionType["toggledPresentationModeSetting"] = "toggledPresentationModeSetting";
  ActionType["toggledSavedSearch"] = "toggledSavedSearch";
  ActionType["tooltipViewed"] = "tooltipViewed";
  ActionType["unfollowedArtist"] = "unfollowedArtist";
  ActionType["unfollowedFair"] = "unfollowedFair";
  ActionType["unfollowedGene"] = "unfollowedGene";
  ActionType["unfollowedPartner"] = "unfollowedPartner";
  ActionType["uploadPhotosCompleted"] = "uploadPhotosCompleted";
  ActionType["viewArtworkMyCollection"] = "viewArtworkMyCollection";
  ActionType["viewedArtworkList"] = "viewedArtworkList";
  ActionType["viewedVideo"] = "viewedVideo";
  ActionType["visitMyCollection"] = "visitMyCollection";
  ActionType["visitMyCollectionOnboardingSlide"] = "visitMyCollectionOnboardingSlide";
})(ActionType || (exports.ActionType = ActionType = {}));